import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../../lib/socketio";
import {isAuthorized} from "../../../lib/authorization";
import { createUserLog } from '../../../lib/api';
import { useSelector } from 'react-redux';

const ControlGroupPR = ({index, column, data, ovrdata1, ovrdata2, internal}) => {

    const [tagdata, settagdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    React.useEffect(() => {
        if (Object.keys(data).length !== 0 && !isCopied) {
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setOpen({...open, [id]:false});
    };


    const handleSubmit = (event, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, {value}, id, min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            setDataCopy({...dataCopy, [id]: value});
            settagdata(event.target.value);
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                });
            }
        }

    }

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            column[i][0].tag_display_subgroup === 'START DATE' ?
                <Grid  width ='500px' key = {column[i]} columns={3} stackable style={styles.grid}>
                    <p style={{
                        textAlign: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        marginTop: '20px',
                        marginBottom: '0px'
                    }}>{typeof column[i][0] !== 'undefined' ? column[i][0].tag_display_subgroup : ''}</p>
                    {column[i].map(r =>
                        <Grid.Column width={3}>
                            <Button
                                key = 'button'
                                type = 'button'
                                size='tiny'
                                disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                content = {data[r.id]}
                                onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                            <Modal
                                key = {r.id}
                                style = {styles.width}
                                open = {open[r.id]}
                                onClose={handleClose[r.id]}
                                onOpen={handleOpen[r.id]}>
                                <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                <Modal.Content>
                                    <form  style = {styles.form} autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                        <Input focus placeholder='Value'
                                               name='Input change'
                                               label = {r.unit || ""}
                                               labelPosition='right'
                                               type='number'
                                               step ='0.0001'
                                               size='small'
                                               autoFocus
                                               min ={r.min}
                                               max ={r.max}
                                               error={isValidationError}
                                               onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                               defaultValue={data[r.id]}
                                        />
                                    </form>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button color='blue' content={'Ok'} disabled={isValidationError} onClick={(event, value) => handleSubmit(event, r.id)}/>
                                    <Button
                                        key = 'button'
                                        content = 'Close'
                                        color = 'red'
                                        style={{marginLeft: '5px', marginTop: '10px'}}
                                        onClick ={  () => handleClose(r.id)}/>
                                </Modal.Actions>
                            </Modal>
                        </Grid.Column>
                    )}
                </Grid>
                :
                <Grid columns='equal' style={styles.grid}>
                    <p style={{
                        textAlign: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        marginTop: '20px',
                        marginBottom: '0px'
                    }}>{typeof column[i][0] !== 'undefined' ? column[i][0].tag_display_subgroup : ''}</p>
                    {column[i].map(r =>
                        <Grid.Row style={{padding: '2px 0'}}>
                            <Grid.Column width={8} style={styles.name}>{r.tag_display_name} </Grid.Column>
                            <Grid.Column width={3}>
                                <Button
                                    key = 'button'
                                    type = 'button'
                                    size='tiny'
                                    disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                    content = {data[r.id]}
                                    onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                <Modal
                                    key = {r.id}
                                    style = {styles.width}
                                    open = {open[r.id]}
                                    onClose={handleClose[r.id]}
                                    onOpen={handleOpen[r.id]}>
                                    <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                    <Modal.Content>
                                        <form  style = {styles.form} autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                            <Input focus placeholder='Value'
                                                   name='Input change'
                                                   label = {r.unit || ""}
                                                   labelPosition='right'
                                                   type='number'
                                                   step ='0.0001'
                                                   size='small'
                                                   autoFocus
                                                   min ={r.min}
                                                   max ={r.max}
                                                   error={isValidationError}
                                                   onChange={(event, value) => handleChange(event, value, r.id,  r.min, r.max, r.display_id)}
                                                   defaultValue={data[r.id]}
                                            />
                                        </form>
                                    </Modal.Content>
                                    <Modal.Actions>
                                        <Button color='blue' content={'Ok'}  disabled={isValidationError} onClick={(event, value) => handleSubmit(event, r.id)}/>
                                        <Button
                                            key = 'button'
                                            content = 'Close'
                                            color = 'red'
                                            style={{marginLeft: '5px', marginTop: '10px'}}
                                            onClick ={  () => handleClose(r.id)}/>
                                    </Modal.Actions>
                                </Modal>
                            </Grid.Column>
                            <Grid.Column style={styles.read} width={17}>{r.unit}</Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
        ))
    ))

    return (
        <Grid.Column key={index} style={{maxWidth: '800px', padding: '10'}}>
            {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    width: {
        maxWidth: '400px'
    },
    name: {
        color: 'yellow',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    },
    read: {
        marginLeft: '50px'
    }
};

export default React.memo(ControlGroupPR);